import { InputAdornment } from '@mui/material';
import { GridSearchIcon } from '@mui/x-data-grid';
import { ComponentProps, FC } from 'react';
import { TextFieldElement } from 'react-hook-form-mui';

export const SearchField: FC<
  Omit<ComponentProps<typeof TextFieldElement>, 'options'>
> = (props) => {
  return (
    <TextFieldElement
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <GridSearchIcon sx={{ color: 'black' }} />
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
};
